import { ICellRendererParams } from '@ag-grid-enterprise/all-modules';
import { is } from 'ramda';
import React from 'react';

import { CONSTANTS } from '../../../../core/config/constants';

const BRANCH_ADDRESS_FIELDS = ['address', 'city', 'country', 'postalCode', 'type'];

const BranchAddressCellRenderer: React.FC<ICellRendererParams> = ({ data }) => {
  const address: string[] = [];

  if (data && is(Object, data?.address)) {
    BRANCH_ADDRESS_FIELDS.forEach((key) => {
      if (data.address[key]) {
        address.push(data.address[key]);
      }
    });
  }

  return <>{address.join(CONSTANTS.RENDERER_ARRAY_SEPARATOR)}</>;
};

export default BranchAddressCellRenderer;
